<template>
    <fragment>
        <button @click="login()" class="button btn-block-with-icon is-fullwidth">
                    <span class="icon">
                      <img src="../images/fb.svg" alt="">
                    </span>
            <span class="btn-text">
              <span v-if="isSignup">Sign up</span>
              <span v-if="!isSignup">Log in</span>
              with Facebook</span>
        </button>
    </fragment>
</template>

<script>
    import {LoginAPI} from "../../../apis/LoginAPI";

    export default {
        name: "FacebookLogin.vue",
        props: ['isSignup'],
        methods: {
            async login() {
                let redirectUrl = await LoginAPI.getFBLoginRURI();
                if (redirectUrl.authorization_url) {
                    window.location.href = redirectUrl.authorization_url
                }
            }
        }
    }
</script>

<style scoped>

</style>
